import type { TEntryStatus } from '@schemas'

export const ENTRY_STATUS_LABELS: Record<TEntryStatus, string> = {
  draft: 'Draft',
  checked_in: 'Checked in',
  not_entered: 'Not Entered',
  judged: 'Judged',
  disqualified: 'Disqualified',
  finalized: 'Finalized',
}
